<!-- src/views/HomePage.vue -->
<template>
  <div class="c-text-between px-container c-flex-wrap">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <span class="c-mb-10" style="text-align: left;">即将推出的产品</span>
      <h1>具身人工智能原型系统</h1>
      <span class="c-mt-10 c-mb-10 c-text-left text-indent">
        探索我们的最新原型——从双臂操控到移动系统的全方位解决方案。为研究人员提供开箱即用、高性价比的配置方案，涵盖遥操作、数据采集与实体化实现。
      </span>
      <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite">立刻咨询</router-link>
        </div>

      </div>
    </div>
    <div class="display-width c-text-align">
        <div style="aspect-ratio:  480/253;    position: relative; height: 0;  padding-bottom: 56.25%; background: black;">
            <div class="bigPlayButton" @click="iframeValue = true"  v-show="!iframeValue">
              <svg viewBox="0 0 32 32">
                <path d="M6.484 4.094l20.75 11.225c0.226 0.121 0.41 0.427 0.41 0.683s-0.184 0.563-0.41 0.683l-20.75 11.222c-0.095 0.051-0.26 0.093-0.367 0.093-0.427 0-0.774-0.346-0.774-0.773v-22.451c0-0.428 0.347-0.774 0.774-0.774 0.108 0 0.272 0.042 0.367 0.093z"></path>
              </svg>
            </div>
          <iframe
              src="https://player.bilibili.com/player.html?bvid=BV1cxNFzPEit" v-if="iframeValue"
              style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
              frameborder="0"
              scrolling="no"
              allowfullscreen="true"
            ></iframe> 
        </div>  
    </div>
  </div>
    <div id="prototypes"></div>
    <div class="line-with-text px-container"  >
      <hr class="divider">
      <span class="line-text">原型
      </span>
      <hr class="divider">
    </div>
  <!-- <div class=" c-pdt-20">   --> 
     
    <div class="c-text-between px-container  c-flex-wrap c-font-14" style="margin-bottom: 120px;">
      <div class="action-width c-text-column c-mb-60">
        <div class="c-mb-5" style="overflow: hidden;">
          <!-- 4b260ce4e6024b3d8814757eb1e1580.jpg -->
          <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera17_03_fp.png" alt="" class="image-style"
            style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight">触觉移动机器人 (TMR)</div>
        <div class="c-text-left ">触觉移动机器人是一款先进的移动研究机器人系统，专为遥操作、移动操控与具身人工智能研究优化设计。该系统可与Franka Research
          3实现无缝集成，助力快速开展研究部署。
        </div>
        <div class="c-text-left c-mt-10">
          <a href="https://franka.de/hubfs/TMR_TwoPager_February2026.pdf?hsLang=en" class="linkTag" target="_blank">
            下载产品概要手册</a>
        </div>

      </div>
      <div class="action-width c-text-column c-mb-60 ">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/251105_Static_Spine_Camera01_fp (1).png" class="image-style" alt=""
            style="height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight">Franka Research 3 Duo (FR3 Duo)</div>
        <div class="c-text-left ">FR3 Duo 是一款用于具身人工智能研究的双臂系统，它在一个优化平台上统一了远程操作、数据收集与策略执行。该产品可配备精选的操作执行器和视觉传感器，从而减少集成工作，并提供可复现的设置，确保在不同实验室间获得可比较的结果。
        </div>
        <div class="c-text-left c-mt-10">
          <a href="https://franka.de/hubfs/FR3Duo_TwoPager_February2026.pdf?hsLang=en" class="linkTag" target="_blank">
            下载产品概要手册</a>
        </div>
      </div>
      <div class="action-width c-text-column c-mb-60">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/251105_MFR3_Duo_Camera01_01_fp.png" class="image-style"
            alt="" style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight">Mobile FR3 Duo</div>
        <div class="c-text-left ">
         Mobile FR3 Duo 将 FR3 Duo 参考平台与触觉移动机器人（TMR）集成，将其扩展至移动环境中。它将双臂操作、丰富感知和全向移动性结合于一个单一的具身AI系统中——使得数据收集和策略执行能够超越固定工作单元的限制。
        </div>
        <div class="c-text-left c-mt-10">
          <a href="https://franka.de/hubfs/MobileFR3Duo_TwoPager_February%202026.pdf?hsLang=en" class="linkTag" target="_blank">
            下载产品概要手册</a>
        </div>
      </div>
      <div class="action-width c-text-column c-mb-60">
        <div class="c-mb-5" style="overflow: hidden;">
          <img src="@/assets/images/productsPage/franka gello duo web.png" class="image-style"
            alt="" style=" height: auto; max-width: 100%;aspect-ratio: 716/450;object-fit: cover;">
        </div>
        <div class="c-text-left c-font-weight">Franka GELLO Duo</div>
        <div class="c-text-left ">
          Franka GELLO Duo 将 GELLO 远程操作界面改造为双机使用模式，实现了对 FR3 Duo 的直接控制。它为研究人员提供了一种自然的方式，用以教授双臂操作技能并为物理人工智能研究收集数据。其硬件和软件均已开源，免费提供给社区使用。
        </div>
        <div class="c-text-left c-mt-10">
          <a href="https://franka.de/hubfs/FrankaGELLODuo_OnePager_February2026.pdf?hsLang=en" class="linkTag" target="_blank">
            下载产品概要手册</a>
        </div>
      </div>
    </div>
  <!-- </div> -->
  
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">核心优势
      </span>
      <hr class="divider">
    </div>

  <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>从远程操控到模型推理</h1>
      <span class="c-mt-5 c-mb-20 c-text-left text-indent">Franka Robotics 的新型原型机基于统一架构构建，可直接部署使用，能支持完整的人工智能流程：从远程操控演示、实时控制，到大规模数据采集与模型推理。
      </span> 
    </div>

    <div class="display-width">
      <img src="@/assets/images/productsPage/260217_MFR3_Duo_Camera21_fp.png" alt=""
        style="    height: auto; max-width: 100%;">
    </div>
  </div>     

  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
    <div class="display-width c-text-column ">
      <h2 class="c-text-left">一体化解决方案，覆盖完整人工智能流程</h2>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
         Franka AI Cells 为机器人学习领域提供全方位功能覆盖，涵盖从远程操控演示、真实环境数据采集，到设备端模型推理与部署的全流程。此外，它们还能为研究人员省去从零设计和搭建 AI 单元所需的大量时间与精力。
      </span>
    </div>
    <div class="display-width c-text-column ">
      <h2 class="c-text-left">最高质量的数据采集</h2>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
        大规模真实场景下的机器人操作数据，是训练智能、多功能机器的基础 —— 这类机器需能在动态、非结构化环境中安全高效地运行。 Franka 的高品质集成传感器，能以无可比拟的保真度捕捉实时交互过程，为具身人工智能提供丰富的数据集。

      </span>
    </div>
  </div>
  <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
    <div class="display-width c-text-column ">
      <h2 class="c-text-left">具身人工智能的基准参考平台</h2>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
        全球研究人员均可借助这一基准参考装置获益：不仅能生成可供共享的数据集，或直接复用他人已有的数据集来训练模型；通过采用统一的装置，他们还能对模型进行微调、直接部署执行策略，并对策略的实际运行性能进行基准测试。
      </span>
    </div>
    <div class="display-width c-text-column ">
      <h2 class="c-text-left">设计赋能可扩展性</h2>
      <span class="c-mt-5 c-mb-5 text-indent" style="text-align: left; ">
        该平台专为支持研究发展而打造，采用模块化设计，可轻松扩展接入摄像头、传感器、计算单元或定制化工具。开放式接口与标准化端口确保所有系统始终保持灵活性与可扩展性，随时能够适应技术演进需求。
      </span>
    </div>
  </div>
  
  <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
    
    <div class="display-width">
      <img src="@/assets/images/productsPage/AI services_resized.png" alt=""
        style="    height: auto; max-width: 100%;">
    </div>
    <div class="display-width c-text-column" style="align-items: flex-start; justify-content: center;">
      <h1>规模化解锁物理智能</h1>
      <span class="c-mt-5 c-mb-20 c-text-left text-indent">Franka Robotics为研发具身智能的企业实验室提供人工智能服务。我们运营并管理着大规模机器人集群，专门采集高质量的物理交互数据。无论您需要数千组训练用数据片段，还是用于模型微调的目标数据，我们都能提供结构化、可复现的数据集，助力您加速人工智能研发进程。
      </span> 
      
        <div class="c-text-justify-start c-flex-wrap c-mt-10 c-mb-10">
          <router-link to="/contact" class="buttonSite">了解更多</router-link>
        </div>

    </div>
 
  </div>     
     <Contact />
</template> 
<script>

import backgroundImage from "@/assets/images/productsPage/FR3 move new 6.png"; 
import Contact from "./contact.vue"; 
export default {
  metaInfo() {
    return {
      title: this.$route.meta.title, // 从路由获取标题
      meta: [
        {
          name: 'keywords',
          content: this.$route.meta.metaTags[0]['content']
        }
      ]
    }
  },
  name: 'HomePage',
  components: {
    Contact
  },
  data() {
    return { 
      iframeValue: false,
      images: [
        { src: require('@/assets/images/productsPage/_Frank Robotics4386_resized (1).jpg'), alt: 'Franka Robotics产品图片1' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0265_resized-1.jpg'), alt: 'Franka Robotics产品图片2' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0304 1_resized.jpg'), alt: 'Franka Robotics产品图片3' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0200_resized.jpg'), alt: 'Franka Robotics产品图片4' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0041_resized.jpg'), alt: 'Franka Robotics产品图片5' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0127_resized.jpg'), alt: 'Franka Robotics产品图片6' },
        { src: require('@/assets/images/productsPage/_Frank Robotics0155_resized.jpg'), alt: 'Franka Robotics产品图片7' }
      ],
      iframe1: '2',
      iframe2: '2',
      backgroundImage: backgroundImage,
      tableData: [
        { name: '基于工作流的应用程序编程', DESK: true, RIDE: false, FCI: false },
        { name: '快速原型设计实验和演示 ', DESK: true, RIDE: false, FCI: false },
        { name: '执行机器人任务', DESK: true, RIDE: false, FCI: true },
        { name: '开发自定义应用程序', DESK: false, RIDE: true, FCI: false },
        { name: '连接第三方硬件', DESK: false, RIDE: true, FCI: true },
        { name: '连接外部资源', DESK: false, RIDE: true, FCI: true },
        { name: '1 kHz 力矩、位置和速度控制 ', DESK: false, RIDE: false, FCI: true },
        { name: '1 kHz 传感器信号和机器人状态的测量', DESK: false, RIDE: false, FCI: true },
        { name: '访问机器人运动学和动力学模型', DESK: false, RIDE: false, FCI: true },
        { name: '与ROS和MATLAB & Simulink的集成', DESK: false, RIDE: false, FCI: true },
      ]
    }

  },
  mounted() { 
  },
  beforeUnmount() { 
  },
  methods: {  }
};
</script>
<style scoped>
.newBack:hover {
  background-color: white;
  color: black;
}
 
.slides-wrapper {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease;
  will-change: transform;
}

.slide {
  flex: 0 0 100%;
  min-width: 100%;
  position: relative;
}

li::marker {
  unicode-bidi: isolate;
  font-variant-numeric: tabular-nums;
  text-transform: none;
  text-indent: 0px !important;
  text-align: start !important;
  text-align-last: start !important;
}

.flex-width {
  width: calc(100% / 7);
}

@media (max-width: 1260px) {
  .flex-width {
    width: calc(100% / 4);
  }
}

@media (max-width: 999px) {
  .flex-width {
    width: calc(100% / 3);
  }
}

@media (max-width: 747px) {
  .flex-width {
    width: calc(100% / 2);
  }
}

@media (max-width: 150px) {
  .flex-width {
    width: 100%
  }
}

.title-width {
  width: 33.33%;
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 899px) {
  .title-width {
    width: 100%
  }
}

.action-height {
  height: 400px;
  background-color: #d5dbdc;
  position: relative;
}

.action-width {
  width: calc(25% - 40px);
}

/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 1029px) {
  .action-width {
    width: calc(50% - 40px);
  }

  .action-height {
    height: 200px;
    background-color: #d5dbdc;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {
  .action-width {
    width: 100%;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  border: 1px solid black;
  padding: 5px;
  text-align: left;
}
</style>